interface IContainer {
  children?: React.ReactNode;
}

export const Container = ({ children, ...restProps }: IContainer & RestProps) => {
  return <div className={`${restProps?.className || ''}`}>{children}</div>;
};
